/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Specifies the type of booking for a cash journal position.
 */
export enum EnumCashJournalPositionBookingType {
    /**
     * Automatic booking type.
     */
    Automatic = 0,
    /**
     * Bank booking type.
     */
    Bank = 1,
    /**
     * External receipt booking type.
     */
    ExternalReceipt = 2,
}
